import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";


const ProtectedRoute = ({ children }) => {
  const [searchParams] = useSearchParams();

  const urlToken = searchParams.get("token");
  const storedToken = sessionStorage.getItem("video_token");

  const token = urlToken || storedToken;

  if (!token) {
    console.warn("⛔ ProtectedRoute: no token found, redirecting to /");
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
